import { Checkbox, TextField, WithStyles } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { styles } from "./AutocompleteUserDropdown.styles";
import * as React from "react";
import Autocomplete from "@material-ui/lab/Autocomplete/Autocomplete";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlankOutlined";

export interface IAutocompleteWithCheckboxesProps extends WithStyles<typeof styles> {
    allItems: any;
    selectedItems: any;
    onChange: any;
    id: string;
    disabled?: boolean;
}

const AutocompleteWithCheckboxesPure: React.FunctionComponent<IAutocompleteWithCheckboxesProps> = ({
    allItems,
    selectedItems,
    onChange,
    id,
    disabled,
    classes
}: IAutocompleteWithCheckboxesProps) => {
    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;

    return (
        <Autocomplete
            disabled={disabled}
            multiple
            id={id}
            options={allItems || []}
            disableCloseOnSelect
            getOptionLabel={option => option.name}
            renderOption={(option, { selected }) => (
                <span>
                    <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        className={classes.checkbox}
                        checked={selected}
                    />
                    {option.name}
                </span>
            )}
            getOptionSelected={(option, value) => option.id === value.id}
            style={{ width: "100%" }}
            renderInput={params => {
                const { InputProps, ...restParams } = params;
                const { startAdornment, ...restInputProps } = InputProps;
                return (
                    <TextField
                        {...restParams}
                        variant="outlined"
                        multiline
                        rows={2}
                        InputProps={{
                            ...restInputProps,
                            startAdornment: (
                                <div
                                    style={{
                                        maxHeight: 80,
                                        overflowY: "auto"
                                    }}
                                >
                                    {startAdornment}
                                </div>
                            )
                        }}
                    />
                );
            }}
            limitTags={3}
            value={selectedItems}
            onChange={(event, newValue) => onChange(newValue)}
        />
    );
};

export const AutocompleteWithCheckboxes = withStyles(styles)(AutocompleteWithCheckboxesPure);
